/* eslint-disable no-undef */
import { clearStorage, retrieveFromStorage, saveToStorage } from "../../Components/Functions";
import { routers } from "../../Constants/routers";
import Api from "../../Server/Api";
import {
	CLOSE,
	UPDATE,
	UPDATERIDER,
	UPDATE_TO_LOCALSTORAGE,
	UPDATE_TO_LOCALSTORAGE_RIDER,
	USER_AUTHENTICATION_DATA,
} from "./types";


const api = new Api();

const INITIAL_STATE = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};
const { user, business } = INITIAL_STATE;

export const updateUser = (data = {}) => {
	const store = { ...data, type: UPDATE };
	saveToStorage({ name: UPDATE_TO_LOCALSTORAGE, value: store });
	return store;
};

export const updateRider = (data = {}) => {
	const store = { ...data, type: UPDATERIDER };
	saveToStorage({ name: UPDATE_TO_LOCALSTORAGE_RIDER, value: store });
	return store;
};

export const saveRiderRecord = (data = {}) => {
	return async (dispatch) => {
		let _data = {
			"id": data?.id,
            "documents": JSON.stringify(data?.documents),
            "name": data?.name,
            "email": data?.email,
            "phone": data?.phone,
            "password": data?.password,
            "base_salary": data?.base_salary,
            "percentage_on_delivery": data?.percentage_on_delivery,
            "business_id": business?.id,
			startpoint_lat: data?.startpoint_lat,
			startpoint_lng: data?.startpoint_lng,
			startpoint_address: data?.startpoint_address,
			startpoint_address_component: data?.startpoint_address_component
		}
		if(data?.image?.includes(";base64,") && data?.image?.includes("data:")){
			_data.image = data?.image
		}
		let res  = null;
		if(_data?.id){
			res = await api.put({ endpoint: "riders/"+_data?.id+"/", data: _data});
		}else{
			res = await api.post({ endpoint: "business/" + business?.identity + "/riders/", data: _data });
		}
		if(res?.id){
			notyf.open({
				type: "success",
				message: data?.id ? "Rider updated successfully" : "New rider created successfully.",
			});
			dispatch({ type: UPDATERIDER, ...res })
		}else{
			notyf.open({
				type: "error",
				message: res?.detail||res?.message||"Rider failed, please try again.",
			});
		}
		
	}
};

export const closePanel = (data = {}) => {
	return {
		...data,
		type: CLOSE,
	};
};

export const logout = () => {
	const data = {};
	return (dispatch) => {
		clearStorage();
		dispatch({ ...data, type: UPDATE });
		window.location = routers.pages.home;
	}
};

export const login = (data = {}) => {
	saveToStorage({ name: USER_AUTHENTICATION_DATA, value: data });
	return {
		...data,
		type: UPDATE,
	};
};

export const refreshUser = () => {
	return async (dispatch) => {
		dispatch({ type: UPDATE, loading: true });
		const res = await api.get({ endpoint: "users/auth_user/" });
		saveToStorage({ name: USER_AUTHENTICATION_DATA, value: { ...INITIAL_STATE, ...res} });
		dispatch({ type: UPDATE, ...res, loading: false });
		if(!res?.user?.is_verified && res?.user?.role === "SPECIALIST"){
			dispatch({
				type: "UPDATE_MESSAGES",
				alert: {
					type: "danger",
					body: `Your account is not verified. Please <a href="${routers.dashboard.profile}">verify</a> account to start receiving patient.`
				}
			})
		}
	};
};

